import { createAction, handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
import React from "react";

import * as dateUtil from "../../../util/dateUtil";

// action types
const SET_PAGE = 'sentMessage/SET_PAGE';
const SET_SIZE = 'sentMessage/SET_SIZE';

const SET_INPUT_START_DATE = 'sentMessage/SET_INPUT_START_DATE';
const SET_INPUT_END_DATE = 'sentMessage/SET_INPUT_END_DATE';
const SET_SELECT_SORT_BY = 'sentMessage/SET_SELECT_SORT_BY';
const SET_INPUT_MESSAGE_NAME = 'sentMessage/SET_INPUT_MESSAGE_NAME';
const SET_SELECT_STATE = 'sentMessage/SET_SELECT_STATE';

const SET_TOTAL = 'sentMessage/SET_TOTAL';
const SET_MESSAGE_LIST = 'sentMessage/SET_MESSAGE_LIST';

const SET_MESSAGE_DETAIL = 'sentMessage/SET_MESSAGE_DETAIL';
const SET_MESSAGE_STAT = 'sentMessage/SET_MESSAGE_STAT';
const SET_MESSAGE_MODIFY = 'sentMessage/SET_MESSAGE_MODIFY';
const SET_MESSAGE_INSPECT = 'sentMessage/SET_MESSAGE_INSPECT';

const SET_UPDATE_MSG_NAME = 'sentMessage/SET_UPDATE_MSG_NAME';
const SET_UPDATE_MSG_SNDDATE = 'sentMessage/SET_UPDATE_MSG_SNDDATE';

// action creators
export const setPage = createAction(SET_PAGE);
export const setSize = createAction(SET_SIZE);

export const setInputStartDate = createAction(SET_INPUT_START_DATE);
export const setInputEndDate = createAction(SET_INPUT_END_DATE);
export const setSelectSortBy = createAction(SET_SELECT_SORT_BY);
export const setInputMessageName = createAction(SET_INPUT_MESSAGE_NAME);
export const setSelectState = createAction(SET_SELECT_STATE);

export const setTotal = createAction(SET_TOTAL);
export const setMessageList = createAction(SET_MESSAGE_LIST);

export const setMessageDetail = createAction(SET_MESSAGE_DETAIL);
export const setMessageStat = createAction(SET_MESSAGE_STAT);
export const setMessageModify = createAction(SET_MESSAGE_MODIFY);
export const setMessageInspect = createAction(SET_MESSAGE_INSPECT);

export const setUpdateMsgName = createAction(SET_UPDATE_MSG_NAME);
export const setUpdateMsgSndDate = createAction(SET_UPDATE_MSG_SNDDATE);

// initial state
const initialState = Map( {
    page: 1,
    size: 10,

    inputStartDate: dateUtil.dateToStr(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
    inputEndDate: "9999-12-31",
    selectSortBy: 'desc',
    inputMessageName: '',
    selectState: '',

    total: 0,
    messageList: [],

    messageDetail: {},
    messageStat: {
        total: {},
        details: [],
    },
    messageModify: [],
    messageInspect: [],

    updateMsgName: '',
    updateMsgSndDate: '',
    updateMsgSndHour: '',
    updateMsgSndMinute: '',
    updateMsgSndInitDate: dateUtil.dateToStr(dateUtil.dateAdd(new Date(), +5)),
})

// reducer
export default handleActions({
    [SET_PAGE]: (state, action) => {
        const page = action.payload;
        return state.set('page', page);
    },
    [SET_SIZE]: (state, action) => {
        const size = action.payload;
        return state.set('size', size);
    },

    [SET_INPUT_START_DATE]: (state, action) => {
        const inputStartDate = action.payload;
        return state.set('inputStartDate', inputStartDate);
    },
    [SET_INPUT_END_DATE]: (state, action) => {
        const inputEndDate = action.payload;
        return state.set('inputEndDate', inputEndDate);
    },
    [SET_SELECT_SORT_BY]: (state, action) => {
        const selectSortBy = action.payload;
        return state.set('selectSortBy', selectSortBy);
    },
    [SET_INPUT_MESSAGE_NAME]: (state, action) => {
        const inputMessageName = action.payload;
        return state.set('inputMessageName', inputMessageName);
    },
    [SET_SELECT_STATE]: (state, action) => {
        const selectState = action.payload;
        return state.set('selectState', selectState);
    },

    [SET_TOTAL]: (state, action) => {
        const total = action.payload;
        return state.set('total', total);
    },
    [SET_MESSAGE_LIST]: (state, action) => {
        const messageList = action.payload;
        return state.set('messageList', messageList);
    },

    [SET_MESSAGE_DETAIL]: (state, action) => {
        const messageDetail = action.payload;
        return state.set('messageDetail', messageDetail);
    },
    [SET_MESSAGE_STAT]: (state, action) => {
        const messageStat = action.payload;
        return state.set('messageStat', messageStat);
    },
    [SET_MESSAGE_MODIFY]: (state, action) => {
        const messageModify = action.payload;
        return state.set('messageModify', messageModify);
    },
    [SET_MESSAGE_INSPECT]: (state, action) => {
        const messageInspect = action.payload;
        return state.set('messageInspect', messageInspect);
    },

    [SET_UPDATE_MSG_NAME]: (state, action) => {
        const updateMsgName = action.payload;
        return state.set('updateMsgName', updateMsgName);
    },
    [SET_UPDATE_MSG_SNDDATE]: (state, action) => {
        const updateMsgSndDate = action.payload;

        let date = updateMsgSndDate.split(" ")[0];
        let hour = updateMsgSndDate.split(" ")[1].split(":")[0];
        let minute = updateMsgSndDate.split(" ")[1].split(":")[1];

        return state
            .set('updateMsgSndDate', date)
            .set('updateMsgSndHour', hour)
            .set('updateMsgSndMinute', minute);
    },
}, initialState)
